import axios from "axios";
import Config from "../globals/Config";

const PORT: string | undefined = Config.port;
const HOST: string | undefined = Config.host;
const APP_VERSION: string | undefined = Config.appVersion;
// Create an Axios instance
const apiClient = axios.create({
	baseURL: `${HOST}:${PORT}`, //DEPLOYMENT WARNING!
	withCredentials: true,
});

// 1. Add Request Interceptor to attach the version header
apiClient.interceptors.request.use(
	(config) => {
		const version = APP_VERSION;
		if (version) {
			config.headers["X-Project-Version"] = version;
		}
		return config;
	},
	(error) => Promise.reject(error),
);

// 2. Expand Response Interceptor
apiClient.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (!error.response) return Promise.reject(error);

		const status = error.response.status;

		// Handle 426: Version Mismatch (Force update/logout)
		if (status === 426) {
			console.warn(
				"Project version outdated. Clearing storage and reloading...",
			);

			// Wipe everything to ensure the user gets a fresh state
			localStorage.clear();
			sessionStorage.clear();
			window.location.href = "/login";

			// Alert first so they know why they are being kicked out
			alert(
				"A new version of the system is available. The page will now reload.",
			);

			return Promise.reject(error);
		}

		// Handle 403: Forbidden (Your existing logic)
		if (status === 403) {
			window.location.href = "/login";
			alert("Access denied. Redirecting to login...");
			return Promise.reject(error);
		}

		return Promise.reject(error);
	},
);

export default apiClient;
